'use client'

import { memo, useEffect, useState } from 'react'
import { NinxlHeroDemoPlayer } from '@/app/ninxl/_components/ninxl-hero-demo-player'
import {
  NINX_EXPLAINER_DEMO_SRC,
  NINX_EXPLAINER_POSTER_SRC,
} from '@/lib/landing-demos'
import { cn } from '@/lib/utils'

/** baby: Any scroll past this hides the play control so the fly-through stays clean */
const SCROLL_HIDE_PX = 1

/**
 * Centered explainer play control for scroll-world heroes.
 * Hides immediately when the user starts scrolling.
 */
export const ScrollWorldExplainerPlay = memo(function ScrollWorldExplainerPlay({
  ariaLabel = 'Watch trailer',
  dialogTitle = 'NINX trailer',
}: {
  ariaLabel?: string
  dialogTitle?: string
}) {
  const [hidden, setHidden] = useState(false)

  useEffect(() => {
    const onScroll = () => {
      // baby: hide as soon as scroll starts: do not fade over the dive
      setHidden(window.scrollY > SCROLL_HIDE_PX)
    }

    window.addEventListener('scroll', onScroll, { passive: true })
    onScroll()

    return () => {
      window.removeEventListener('scroll', onScroll)
    }
  }, [])

  return (
    <div
      className={cn(
        'pointer-events-none fixed inset-0 z-[35] transition-opacity duration-100',
        hidden ? 'opacity-0' : 'opacity-100',
      )}
      aria-hidden={hidden}
    >
      {/* baby: Keep player mounted so an open dialog can finish; only block clicks when hidden */}
      <div className={cn(hidden ? 'pointer-events-none' : 'pointer-events-auto')}>
        <NinxlHeroDemoPlayer
          demoSrc={NINX_EXPLAINER_DEMO_SRC}
          posterSrc={NINX_EXPLAINER_POSTER_SRC}
          ariaLabel={ariaLabel}
          dialogTitle={dialogTitle}
          triggerLabel="Watch trailer"
        />
      </div>
    </div>
  )
})
